import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { scrollUpPage, updateProductGridColumns } from "src/_utils/elements";
import { CSS } from "src/_utils/styles";
import { getQueryParams } from "src/_utils/urls";
import { Btn, H6, Image, LI, P, UL } from "src/AbstractElements";
import { EBSSSPagination } from "src/base/atoms/EBSSSPagination";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import { remotePath } from "src/base/settings/Paths";
import { Card, CardBody, CardHeader, Col, Container, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalHeader, Row } from "reactstrap";
import { ChevronDown, XCircle } from "react-feather";

export const SellerSorting = ({ setSortBy, sortBy }) => {
  const { trans } = useEBSSSLayout();
  const filterSortFunc = (value) => {
    setSortBy(value);
  };
  return (
    <Fragment>
      <Col md="9" sm="10" className="text-end">
        <div className="select2-drpdwn-product select-options d-inline-block" onChange={(e: any) => filterSortFunc(e.target.value)}>
          <Input className="form-control btn-square" type="select" name="select">
            <option value="">{trans("website.relevance")}</option>
            <option value="HIGH_PRICE">{trans("website.prices_high_to_low")}</option>
            <option value="LOW_PRICE">{trans("website.prices_low_to_high")}</option>
            <option value="LOW_ALPHABETICAL">{trans("website.alphabetical_a_to_z")}</option>
            <option value="HIGH_ALPHABETICAL">{trans("website.alphabetgical_z_to_a")}</option>
          </Input>
        </div>
      </Col>
    </Fragment>
  );
};

export const SellerTotal = ({ setSortBy, sortBy }) => {
  const gridLayout = () => {
    document.querySelector(".product-wrapper-grid").classList.remove("list-view");
    var elems = document.querySelector(".gridRow").childNodes;
    [].forEach.call(elems, function (el) {
      el.className = "";
      el.classList.add("col-xl-3");
      el.classList.add("col-sm-6");
      el.classList.add("xl-4");
    });
  };
  const listLayout = () => {
    document.querySelector(".product-wrapper-grid").classList.add("list-view");
    var elems = document.querySelector(".gridRow").childNodes;
    [].forEach.call(elems, function (el) {
      el.className = "";
      el.classList.add("col-xl-12");
    });
  };
  const LayoutView = (layoutColumns) => {
    if (!document.querySelector(".product-wrapper-grid").classList.contains("list-view")) {
      var elems = document.querySelector(".gridRow").childNodes;
      [].forEach.call(elems, function (el) {
        el.className = "";
        el.classList.add("col-xl-" + layoutColumns);
      });
    }
  };
  return (
    <Fragment>
      <Row className="m-b-10">
        <Col md="3" sm="2" className="products-total">
          {/* <>
          <div className="square-product-setting d-inline-block">
            <a className="icon-grid grid-layout-view" onClick={gridLayout} href="#javascript">
              <Grid />
            </a>
          </div>
          <div className="square-product-setting d-inline-block">
            <a className="icon-grid m-0 list-layout-view" onClick={listLayout} href="#javascript">
              <List />
            </a>
          </div>
          </> */}
          <div
            className="d-none-productlist filter-toggle"
            onClick={() => {
              /*setFilterSidebar(!filterSidebar)*/
              document.querySelector(".product-wrapper.container-fluid").classList.toggle("sidebaron");
              document.querySelector(".product-sidebar").classList.toggle("open");
            }}
          >
            <H6 attrH6={{ className: "mb-0" }}>
              Filters
              <span className="ms-2">
                <ChevronDown className="toggle-data " />
              </span>
            </H6>
          </div>
          {false ? (
            <div className="grid-options d-inline-block">
              <UL attrUL={{ className: "simple-list", as: "ul" }}>
                <LI>
                  <a className="product-2-layout-view" onClick={() => LayoutView(6)} href="#javascript">
                    <span className="line-grid line-grid-1 bg-primary"></span>
                    <span className="line-grid line-grid-2 bg-primary"></span>
                  </a>
                </LI>
                <LI>
                  <a className="product-3-layout-view" onClick={() => LayoutView(4)} href="#javascript">
                    <span className="line-grid line-grid-3 bg-primary"></span>
                    <span className="line-grid line-grid-4 bg-primary"></span>
                    <span className="line-grid line-grid-5 bg-primary"></span>
                  </a>
                </LI>
                <LI>
                  <a className="product-4-layout-view" onClick={() => LayoutView(3)} href="#javascript">
                    <span className="line-grid line-grid-6 bg-primary"></span>
                    <span className="line-grid line-grid-7 bg-primary"></span>
                    <span className="line-grid line-grid-8 bg-primary"></span>
                    <span className="line-grid line-grid-9 bg-primary"></span>
                  </a>{" "}
                </LI>
                <LI>
                  <a className="product-6-layout-view" onClick={() => LayoutView(2)} href="#javascript">
                    <span className="line-grid line-grid-10 bg-primary"></span>
                    <span className="line-grid line-grid-11 bg-primary"></span>
                    <span className="line-grid line-grid-12 bg-primary"></span>
                    <span className="line-grid line-grid-13 bg-primary"></span>
                    <span className="line-grid line-grid-14 bg-primary"></span>
                    <span className="line-grid line-grid-15 bg-primary"></span>
                  </a>
                </LI>
              </UL>
            </div>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export const CategorySeller = ({ categories, categoryPath, basePath }) => {
  const { trans } = useEBSSSLayout();
  const colorHandle = (event, color) => {
    var elems = document.querySelectorAll(".color-selector ul li");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
    event.target.classList.add("active");
    //filterColor(color);
  };
  const clickBrandHendle = (event, brands) => {
    var index = brands.indexOf(event.target.value);
    if (event.target.checked === true) brands.push(event.target.value);
    else brands.splice(index, 1);
    //filterBrand(brands);
  };

  return (
    <Fragment>
      <div className="product-filter">
        <H6 attrH6={{ className: "f-w-600" }}>Category</H6>
        <div className="checkbox-animated mt-0">
          <div className="categories-list" style={CSS({ height: 300 })}>
            <div className="product-cat ps-container ps-theme-default ps-active-y" id="categories" style={CSS({ height: 300 })}>
              <ul className="treeview list-group list-group-flush" style={CSS({ height: 300, overflowY: "scroll" })}>
                <li key={"all"} className="list-group-item">
                  <Link to={basePath ? `${process.env.PUBLIC_URL}${basePath}?page=1` : `${process.env.PUBLIC_URL}/sellers?page=1`}>
                    <span>{trans("website.all")}</span>
                  </Link>
                </li>
                {categories?.map((cat) => {
                  return (
                    <li key={cat.token} className="list-group-item">
                      <Link
                        to={
                          categoryPath
                            ? `${process.env.PUBLIC_URL}${categoryPath}/${cat.id}?page=1`
                            : `${process.env.PUBLIC_URL}/sellers/category/${cat.id}?page=1`
                        }
                      >
                        <span>{cat.title}</span>
                      </Link>
                      {cat.childrens && Array.isArray(cat.childrens) && cat.childrens?.length > 0 ? (
                        <ul className="list-group list-group-flush">
                          {cat.childrens?.map((catc) => {
                            return (
                              <li key={catc.token} className="list-group-item">
                                <Link
                                  to={
                                    categoryPath
                                      ? `${process.env.PUBLIC_URL}${categoryPath}/${catc.id}?page=1`
                                      : `${process.env.PUBLIC_URL}/sellers/category/${catc.id}?page=1`
                                  }
                                >
                                  <span>{catc.title}</span>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <></>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="product-filter d-none">
        <H6 attrH6={{ className: "f-w-600" }}>Brand</H6>
        <div className="checkbox-animated mt-0">
          {[].map((brand, index) => {
            return (
              <Label className="d-block" key={index}>
                <Input
                  className="checkbox_animated"
                  onClick={(e) => clickBrandHendle(e, [])}
                  value={brand}
                  defaultChecked={[].includes(brand) ? true : false}
                  id={brand}
                  type="checkbox"
                  data-original-title=""
                  title=""
                />
                {brand}
              </Label>
            );
          })}
        </div>
      </div>
      <div className="product-filter slider-product d-none">
        <H6 attrH6={{ className: "f-w-600" }}>Colors</H6>
        <div className="color-selector">
          <UL attrUL={{ className: "simple-list d-flex flex-row" }}>
            {[].map((color, i) => {
              return (
                <Fragment key={i}>
                  <LI
                    attrLI={{
                      className: color,
                      title: color,
                      onClick: (e) => colorHandle(e, color),
                    }}
                  ></LI>{" "}
                  &nbsp;
                </Fragment>
              );
            })}
          </UL>
        </div>
      </div>
    </Fragment>
  );
};

export const SellerSidebar = ({ categories, sortBy, setSortBy, categoryPath, searchPath, basePath, onlyInput }: any) => {
  const { trans } = useEBSSSLayout();
  const [sidebaron, setSidebaron] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const debounceTimeoutRef = useRef(null);
  const history = useNavigate();
  const params = useParams();

  console.log("params: ", params);

  useEffect(() => {
    if (params.name) {
      setSearchKeyword(params.name);
    }
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const handleChangeBouncer = (event, value: string) => {
    if (!value) {
      history(searchPath ? `${process.env.PUBLIC_URL}${basePath}?page=1` : `${process.env.PUBLIC_URL}/sellers?page=1`);
      return;
    }

    setSearchKeyword(value);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      history(searchPath ? `${process.env.PUBLIC_URL}${searchPath}/${value}?page=1` : `${process.env.PUBLIC_URL}/sellers/search/${value}?page=1`);
    }, 1500);
  };

  const onClickFilter = () => {
    setSidebaron((prevSidebaron) => !prevSidebaron);
    const productWrapper = document.querySelector(".product-wrapper");
    if (productWrapper) {
      productWrapper.classList.toggle("sidebaron", !sidebaron);
    }
  };

  return (
    <Fragment>
      <Row>
        <Col md="12">
          <div className="pro-filter-sec">
            {!onlyInput ? (
              <div className={`product-sidebar ${sidebaron ? "" : "open"}`}>
                <div className="filter-section">
                  <Card>
                    <CardHeader
                      style={CSS({ cursor: "pointer", flexDirection: "row", display: "flex", justifyContent: "space-between" })}
                      onClick={onClickFilter}
                    >
                      <H6 attrH6={{ className: "mb-0 f-w-600 d-flex align-items-center" }}>
                        <span className="fs-6">
                          <i className="fa fa-chevron-down toggle-data mb-1 me-1" style={CSS({ fontSize: 12 })}></i>
                        </span>
                        {trans("website.filters")}
                      </H6>
                      <Link to={process.env.PUBLIC_URL + "/sellers/addresses"}>
                        <i className="la la-map-pin"></i>
                        {trans("website.map")}
                      </Link>
                    </CardHeader>

                    <div className="left-filter">
                      <CardBody className="filter-cards-view animate-chk">
                        <CategorySeller categories={categories} categoryPath={categoryPath} basePath={basePath} />
                        <div className="product-filter text-center d-none">
                          <Image
                            attrImage={{
                              className: "img-fluid banner-product",
                              src: `${"banner"}`,
                              alt: "",
                            }}
                          />
                        </div>
                      </CardBody>
                    </div>
                  </Card>
                </div>
              </div>
            ) : (
              <></>
            )}

            <div className="product-search">
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (debounceTimeoutRef.current) {
                    clearTimeout(debounceTimeoutRef.current);
                  }
                  history(
                    searchPath
                      ? `${process.env.PUBLIC_URL}${searchPath}/${searchKeyword}?page=1`
                      : `${process.env.PUBLIC_URL}/sellers/search/${searchKeyword}?page=1`
                  );
                }}
              >
                <div className="form-group m-0 d-flex align-items-center">
                  {searchKeyword ? (
                    <XCircle
                      size={16}
                      style={CSS({ position: "absolute", cursor: "pointer", marginTop: -12.5, marginLeft: 20 })}
                      onClick={() => {
                        setSearchKeyword("");
                        history(searchPath ? `${process.env.PUBLIC_URL}${basePath}?page=1` : `${process.env.PUBLIC_URL}/sellers?page=1`);
                      }}
                      onTouchStart={() => {
                        setSearchKeyword("");
                        history(searchPath ? `${process.env.PUBLIC_URL}${basePath}?page=1` : `${process.env.PUBLIC_URL}/sellers?page=1`);
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  <Input
                    className="form-control"
                    style={CSS(searchKeyword ? { paddingLeft: 50 } : {})}
                    type="text"
                    placeholder={trans("common.search")}
                    id="product-query"
                    value={searchKeyword}
                    onChange={(e) => handleChangeBouncer(e, e.target.value)}
                  />
                  {!onlyInput ? <i className="fa fa-search"></i> : <></>}
                </div>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export const SellersFeatures = ({ categories, sortBy, setSortBy, categoryPath, searchPath, basePath }: any) => {
  return (
    <Fragment>
      <div className="feature-products">
        <SellerTotal setSortBy={setSortBy} sortBy={sortBy} />
        <SellerSidebar categories={categories} sortBy={sortBy} setSortBy={setSortBy} categoryPath={categoryPath} searchPath={searchPath} basePath={basePath} />
      </div>
    </Fragment>
  );
};

export const SellersGrid = ({ data, sortBy, trans, perLine }) => {
  const [toShowGrid, setToShowGrid] = useState(false);
  const { loaded } = useEBSSS();
  const history = useNavigate();

  useEffect(() => {
    setToShowGrid(!loaded);
  }, [loaded]);

  useEffect(() => {
    if (!toShowGrid) {
      let fadeGrid = setTimeout(() => {
        document.querySelector(".product-wrapper-grid")?.classList?.add("show");
        clearTimeout(fadeGrid);
      }, 150);
    }
  }, [toShowGrid]);

  return (
    <Fragment>
      <div className={`product-wrapper-grid fade-container-products `}>
        <Row className="gridRow">
          {!!data ? (
            data?.map((item) => {
              return (
                <div
                  id="gridId"
                  className={`${
                    // layoutColumns === 3
                    //   ? "ebsss-hover-grid-item col-xl-3 col-lg-6 col-sm-6 xl-4"
                    //   : "ebsss-hover-grid-item col-xl-" + layoutColumns
                    `ebsss-hover-grid-item ${updateProductGridColumns(perLine ? Number(perLine) : 4)}`
                  }`}
                  key={item.id}
                >
                  {item?.alternative_store ? (
                    <Card
                      className="product-box-card"
                      style={CSS({ cursor: "pointer" })}
                      onClick={() => history(`${process.env.PUBLIC_URL}/crm/seller/${item?.token}`)}
                    >
                      <div className="product-box">
                        <div className="product-img" style={CSS({ minHeight: 300 })}>
                          <Image
                            attrImage={{
                              className: "img-fluid w-100 h-100",
                              src: `${item?.photo ? remotePath.assetsUrl(item?.photo) : "https://www.coop.se/Assets/Images/missing-image-product.png"}`,
                              alt: "",
                            }}
                          />
                        </div>
                        <div className="product-details">
                          <div className="rating d-none">
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                          </div>
                          <Link to={`${process.env.PUBLIC_URL}/crm/seller/${item?.token}`} className="fs-5">
                            {item.name}
                          </Link>
                        </div>
                      </div>
                    </Card>
                  ) : (
                    <Card
                      className="product-box-card"
                      style={CSS({ cursor: "pointer" })}
                      onClick={() => history(`${process.env.PUBLIC_URL}/crm/seller/${item?.username}`)}
                    >
                      <div className="product-box">
                        <div className="product-img" style={CSS({ minHeight: 300 })}>
                          <Image
                            attrImage={{
                              className: "img-fluid w-100 h-100",
                              src: `${
                                item.profile.avatar ? remotePath.assetsUrl(item.profile.avatar) : "https://www.coop.se/Assets/Images/missing-image-product.png"
                              }`,
                              alt: "",
                            }}
                          />
                        </div>
                        <div className="product-details">
                          <div className="rating d-none">
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                            <i className="fa fa-star font-warning"></i>
                          </div>
                          <Link to={`${process.env.PUBLIC_URL}/crm/seller/${item?.username}`} className="fs-5">
                            {item.fullName}
                          </Link>
                          <P>{item.note}</P>
                        </div>
                      </div>
                    </Card>
                  )}
                </div>
              );
            })
          ) : (
            <Image
              attrImage={{
                className: "img-fluid m-auto",
                src: "errorImg",
                alt: "",
              }}
            />
          )}
        </Row>
      </div>
    </Fragment>
  );
};
